export const colors = {
  bg: "#06060B",
  surface: "#0F0F17",
  surfaceLight: "#171722",
  primary: "#ADFF00",
  purple: "#7C3AED",
  strava: "#FC5200",
  white: "#FFFFFF",
  gray: "#6B7280",
  grayLight: "#9CA3AF",
  success: "#22C55E",
  danger: "#EF4444",
  amber: "#F59E0B",
  border: "rgba(255,255,255,0.05)",
  borderLight: "rgba(255,255,255,0.1)",
};
